<template>
  <div class="recharge" :style="{ '--buttonColor': '#008EA7' }">
    <Navbar :title="$t('newAdd.Recharge')" />
    <div class="times">
      <div class="recharge_amount">
        <div class="title">{{ $t("newAdd.RechargeAmount") }}:&nbsp;</div>
        <div class="value">{{ $money(payData.money, false) }}</div>
      </div>
      <div class="time">{{ $format(time * 1000, 'mm:ss') }}</div>
    </div>
    <!-- <div class="input_bar">
      <div class="title">{{ $t("newAdd.RechargeAmount") }}</div>
      <van-field center v-model="bankName" :placeholder="$t('rechargeAccountEnter')" />
    </div> -->
    <van-cell-group class="payInfo_bar">
      <div class="title">{{ $t("银行/钱包") }}:</div>
      <van-cell :title="payData.setting.open">
      </van-cell>
      <div class="title">{{ $t("账号") }}:</div>
      <van-cell :title="payData.setting.card">
        <Btn @click="copy('card')" slot="default" color="var(--navBg)">
          {{ $t("newAdd.copy") }}
        </Btn>
      </van-cell>
      <div class="title">{{ $t("账户姓名") }}:</div>
      <van-cell :title="payData.setting.name">
        <Btn @click="copy('name')" slot="default" color="var(--navBg)">
          {{ $t("newAdd.copy") }}
        </Btn>
      </van-cell>
      <div class="title">{{ $t("电话号码") }}:</div>
      <van-cell :title="payData.setting.phone || ''">
        <Btn @click="copy('phone')" slot="default" color="var(--navBg)">
          {{ $t("newAdd.copy") }}
        </Btn>
      </van-cell>
      <div class="title">{{ $t("订单号") }}:</div>
      <van-cell :title="payData.payid">
        <Btn @click="copy('payid')" slot="default" color="var(--navBg)">
          {{ $t("newAdd.copy") }}
        </Btn>
      </van-cell>
      <div class="title">{{ $t("上传证明") }}:</div>
      <div class="upload_img">
        <van-uploader v-model="cert" :after-read="card_frontUpload" :show-upload="cert.length === 0"
          :deletable="status === 0" @delete="deleteImage('cert')" />
      </div>
    </van-cell-group>
    <div class="submit_btn">
      <Btn @click="confirm" slot="default" color="var(--btn_bg)" block>
        {{ $t("newAdd.completePayment") }}
      </Btn>
    </div>
  </div>
</template>

<script>
import {
  Icon,
  Image as VanImage,
  Toast,
  Field,
  CellGroup,
  Cell,
  Button as Btn,
  Dialog,
  Uploader
} from "vant";
import { RECHARGE_COMMIT } from "@/api";
import Navbar from "@/components/JNav";
import { $upload } from "@/utils/request.js";
export default {
  components: {
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    Btn,
    Toast,
    Navbar,
    [Dialog.Component.name]: Dialog.Component,
    [Uploader.name]: Uploader,
  },
  data() {
    return {
      payData: {},
      steps: [],
      bankName: "",
      time: 300,
      timer: null,
      cert: [],
      status: 0
    };
  },
  methods: {
    deleteImage(which) {
      (this[which] = []), (this.payData[which] = "");
    },
    readImg(file) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const reader = new FileReader();
        reader.onload = function (e) {
          img.src = e.target.result;
        };
        reader.onerror = function (e) {
          reject(e);
        };
        reader.readAsDataURL(file);
        img.onload = function () {
          resolve(img);
        };
        img.onerror = function (e) {
          reject(e);
        };
      });
    },
    async compressImg(file) {
      const img = await this.readImg(file);
      const type = img.type;
      return new Promise((resolve, reject) => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        const { width: originWidth, height: originHeight } = img;
        // 最大尺寸限制
        const maxWidth = 1000;
        const maxHeight = 1000;
        // 目标尺寸
        let targetWidth = originWidth;
        let targetHeight = originHeight;
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > 1) {
            //  宽图片
            targetWidth = maxWidth;
            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
          } else {
            // 高图片
            targetHeight = maxHeight;
            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
          }
        }
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        context.clearRect(0, 0, targetWidth, targetHeight);
        // 图片绘制
        context.drawImage(img, 0, 0, targetWidth, targetHeight);
        canvas.toBlob(function (blob) {
          resolve(blob);
        }, type || "image/png");
      });
    },
    async card_frontUpload(event) {
      event.status = "uploading";
      event.message = this.$t("upload.uploading");
      const formdata = new FormData();
      try {
        const ImgData = await this.compressImg(event.file);
        const fileData = new File([ImgData], event.file.name, {
          type: ImgData.type,
        });
        formdata.append("image", fileData);
      } catch (error) {
        formdata.append("image", event.file);
      }
      $upload({ url: "/users/upload", data: formdata })
        .then((res) => {
          if (res.ret === 1) {
            event.status = "success";
            event.message = "";
            this.payData.cert = res.data.path;
          } else {
            event.status = "failed";
            event.message = this.$t("upload.failed");
          }
        })
        .catch((err) => {
          event.status = "failed";
          event.message = this.$t("upload.failed");
          // this.$toast(this.$t("uploadErr"));
        });
    },
    downloadQr() {
      // download(this.payData.qrimg, "mycode.png", "image");
      this.$router.back();
    },
    copy(which) {
      if (which == 'payid') return this.$copyText(this.payData[which]).then((e) => {
        Toast(this.$t("复制成功"));
      });
      this.$copyText(this.payData.setting[which]).then((e) => {
        Toast(this.$t("复制成功"));
      });
    },
    confirm() {
      if(!this.payData.cert) return Toast(this.$t('请上传证明'));
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      RECHARGE_COMMIT({
        id: this.payData.id,
        payid: this.payData.payid,
        money: this.payData.money,
        account: this.payData.account,
        pay_account: this.bankName,
        cert: this.payData.cert,
        isbefore: 1,
      }).then((r) => {
        Toast.clear();
        if (r.data.ret === 3) {
          Toast.clear();
          // Toast
          this.$router.back();
          // window.location.href = r.data.data.url;
        } else {
          // Toast('System exception, please try again later')
          Toast(r.data.msg);
        }
      })
        .catch((e) => {
          Toast.clear();
          console.error(e);
        });
    },
    timeChange(time) {
      let times = time;
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      };
      this.timer = setInterval(() => {
        if (times == 0) {
          clearInterval(this.timer);
          Dialog.confirm({
            message: this.$t('当前订单已过期'),
            showCancelButton: true,
            cancelButtonText: this.$t('My.Button.One'),
            confirmButtonText: this.$t('My.Button.Two'),
          }).then(() => {
            if (this.timer) {
              clearInterval(this.timer)
              this.timer = null
            };
            this.paySubmit();
          }).catch(() => {
            this.$router.back()
          });
          return
        }
        times--;
        this.time = times
      }, 1000)
    },
    paySubmit() {
      Toast.loading();
      RECHARGE_COMMIT({
        id: this.payData.id,
        money: this.payData.money,
        account: this.payData.account,
      }).then((r) => {
        Toast.clear();
        if (r.data.ret === 2) { } else if (r.data.ret === 1) { } else if (r.data.ret === 3) {
          r.data.data.step = this.payData.step;
          r.data.data.id = this.payData.id;
          this.payData = r.data.data;
          this.timeChange(r.data.data.timeout);
          this.$cookie.set("qrPayData", JSON.stringify(r.data.data));
        } else {
          Toast(r.data.msg);
        }
      }).catch((e) => { Toast.clear(); });
    },
  },
  created() {
    let payData = this.$route.params.payData;
    if (payData) {
      this.payData = payData;
      this.$cookie.set("qrPayData", JSON.stringify(this.payData));
    } else {
      this.payData = JSON.parse(this.$cookie.get("qrPayData"));
    }
    this.timeChange(this.payData.timeout);
    this.steps = this.payData.step.split(/[0-9]./);
    for (let i = 0; i < this.steps.length; i++) {
      let item = this.steps[i];
      if (item == "") {
        this.steps.splice(i, 1);
      }
    }
  },
  mounted() { },
  destroyed() {
    // this.$cookie.remove("qrPayData");
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style lang="less" scoped>
@Color: var(--theme);
@wrapPadding: calc(12rem / 16);
@comRadius: 10px;
// @comBG: #07304a;
@comBG: var(--bg1);

.recharge {
  position: relative;
  font-family: "PingFang-Regular";
  height: 100%;
  min-height: 100vh;
  overflow: hidden;
  background: var(--bg);

  .title {
    color: #333;
    font-size: calc(14rem / 16);
    // text-indent: 0.7em;
  }

  .times {
    margin: @wrapPadding;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .recharge_amount {
      display: flex;
      align-items: center;

      .title {
        font-weight: bold;
      }

      .value {
        color: var(--navBg);
        margin-left: calc(6rem / 16);
        font-size: calc(15rem / 16);
      }
    }

    .time {
      color: var(--navBg);
      font-size: calc(15rem / 16);
    }
  }

  .input_bar {
    margin: @comRadius;

    /deep/ .van-field {
      background: var(--light);
      border-radius: calc(6rem / 16);
      margin-top: calc(6rem / 16);
      border: 1px solid #e4e4e4;

      input::placeholder {
        color: grey;
        opacity: 0.6;
      }

      input {
        color: #333;
      }
    }
  }

  .payInfo_bar {
    background: @comBG;
    margin: @wrapPadding;
    border-radius: @comRadius;
    overflow: hidden;

    &::after {
      border: none;
    }

    .title {
      margin-left: calc(10rem / 16);
      font-weight: bold;
    }

    .upload_img {
      padding: 10px 16px;
      /deep/ .van-uploader__upload {
        width: calc(110rem / 16);
        height: calc(110rem / 16);
      }

      /deep/ .van-uploader__preview-image {
        width: calc(110rem / 16);
        height: calc(110rem / 16);
      }

      /deep/ .van-uploader__preview-delete {
        width: 20px;
        height: 20px;

        .van-uploader__preview-delete-icon {
          font-size: 22px;
        }
      }
    }

    .van-cell {
      background: @comBG;
      align-items: center;
      justify-content: space-between;

      .van-cell__title {
        color: var(--textColor);
      }

      .van-button {
        height: calc(32rem / 16);
        border-radius: 6px;
      }
    }

    .step_wrap {
      margin: 16px;
      font-size: calc(12rem / 16);

      .step_title {
        color: #333;
      }

      .step_content {
        color: #666;

        >div {
          margin-top: calc(6rem / 16);
        }
      }
    }
  }

  .submit_btn {
    margin: @wrapPadding;
    border-radius: 4px;
    overflow: hidden;
    margin-top: calc(46rem / 16);
  }

  .van-nav-bar {
    background-color: #ff0000;

    /deep/ .van-nav-bar__content {
      background-color: #ff0000;
    }

    /deep/.van-nav-bar__title {
      color: var(--textColor);
    }

    button {
      background-color: #ff0000;
      border: none;
      color: var(--textColor);
      font-size: calc(10rem / 16);
    }

    .iconfont {
      font-size: calc(22rem / 16);
      color: var(--textColor);
    }
  }

  .content-wrap {
    // width: 100vw;
    min-height: 100vh;
    // background-color: #f4f8f9;
    position: relative;
    overflow: hidden;

    .content {
      padding: 1.375rem 0.875rem;
    }
  }
}
</style>

<style scoped>
.top10 {
  margin-top: 0.625rem;
}

.top6 {
  margin-top: 0.375rem;
}

.top16 {
  margin-top: 1rem;
}

.padding16 {
  padding: 1rem;
}

.padding10 {
  padding: 0.625rem;
}

.white-back {
  background-color: #fff;
}

.font12 {
  font-size: 0.75rem;
}

.font14 {
  font-size: 0.875rem;
}

.font16 {
  font-size: 1rem;
}

.font18 {
  font-size: 1.125rem;
}

.font22 {
  font-size: 1.375rem;
}

.color-red {
  color: #ff0000;
}

.flex {
  display: flex;
}

.between {
  justify-content: space-between;
}

.width100pre {
  width: 100%;
}

.address-wrap {
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* .copy {
} */
.center-ver {
  align-items: center;
}

.center-hor {
  justify-content: center;
}

.line1 {
  line-height: 1.1;
}

.fixed {
  position: fixed;
}

.btn-wrap {
  bottom: 0;
  /* width: 100vw; */
}

.btn-wrap>.left,
.right {
  width: 50vw;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--textColor);
}

.btn-wrap>.left {
  background-color: #3eb3ff;
}

.btn-wrap>.right {
  background-color: #dc1323;
}
</style>